import init from "../../common/base/init"

init(() => {
  const articlePdfLinks = document.querySelectorAll("a.js-document-pdf")
  if (articlePdfLinks.length === 0) return

  // Cache to track ongoing requests to prevent duplicate fetches
  const pendingRequests = new Map();

  const updateLinksForFile = (fileName, url) => {
    // Update all links with the same fileName
    Array.prototype.forEach.call(articlePdfLinks, function(linkEl) {
      if (linkEl.dataset.name === fileName) {
        linkEl.href = url;
      }
    });
  };

  const fetchDocumentUrl = (linkEl) => {
    const fileName = linkEl.dataset.name;
    const slug = linkEl.dataset.slug;
    const type = linkEl.dataset.type;

    // Skip if there's already a pending request for this fileName
    if (pendingRequests.has(fileName)) {
      return;
    }

    // Mark as pending
    pendingRequests.set(fileName, true);

    fetch(`/api/v1/document_url?slug=${slug}&filename=${fileName}&type=${type}`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        if (data.url) {
          updateLinksForFile(fileName, data.url);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        // Remove from pending requests
        pendingRequests.delete(fileName);
      });
  };

  setInterval(() => {
    // Group links by fileName to avoid duplicate processing
    const processedFileNames = new Set();

    Array.prototype.forEach.call(articlePdfLinks, function(linkEl) {
      const fileName = linkEl.dataset.name;

      // Skip if we've already processed this fileName in this interval
      if (processedFileNames.has(fileName)) {
        return;
      }

      processedFileNames.add(fileName);
      fetchDocumentUrl(linkEl);
    });
  }, 1000 * 60 * 5);
})
